import config from 'config/config'
import React from 'react'
import { Button } from 'semantic-ui-react'

export default class Pagination extends React.Component {
  render() {
    const { currentPage, totalPages } = this.props
    const { setPageNumber } = this.props
    const dark = config.theme.dark

    return (
      <Button.Group size="tiny">
        <Button
          inverted={dark}
          icon="chevron left"
          disabled={currentPage === 0}
          onClick={(event) => {
            event.preventDefault()
            setPageNumber(currentPage - 1)
          }}
        />
        <Button
          inverted={dark}
          disabled
          content={currentPage + 1 + ' / ' + totalPages}
        />
        <Button
          inverted={dark}
          icon="chevron right"
          disabled={currentPage + 1 === totalPages}
          onClick={(event) => {
            event.preventDefault()
            setPageNumber(currentPage + 1)
          }}
        />
      </Button.Group>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/MediaBrowser/Pagination.jsx